/*
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
import {
    html,
    Polymer
} from '@polymer/polymer/polymer-legacy.js';
/**
 * This element is used to show the processing loader 
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-processing-loader-demo.html
 * @summary Technical component
*/
const template = html`
    <style include="login-styles">
        .app_processing_dialog{
            z-index: 150;
            background-color: var(--disabled-dark-color);
            color: var(--primary-dark-color);
            position: fixed;
            width: 100%;
            height: 100vh;
            left: 0px;
        }
		:dir(rtl) .app_processing_dialog{
            z-index: 150;
            background-color: var(--disabled-dark-color);
            color: var(--primary-dark-color);
            position: fixed;
            width: 100%;
            height: 100vh;
            left: auto;
			right: 0px;
        }
        .padding{
            padding:16px;
        }
        .loader-desktop {
            display:none;
        }
        .pre-loader-logo {
            height: 90px;
         }
        /* styles for loader starts here */
        @media (max-width:479px){
          .loader-desktop {
              display:none;
          }
          .loader-mobile-background {
             background-color: var(--primary-dark-color) !important; 
             opacity: 0.57;
             height: 100vh;
             width:100vh;
             position: relative;             
          }
          .pre-loader-text {
            color:var(--primary-light-color); 
            text-align:center;
            margin: 10px auto;
        }
        .pre-loader-logo {
            width:50px;
            display:block;                   
            margin-left: auto;
            margin-right: auto;
         }
         .sub-pre-loader {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-right: auto;
            transform: translate(-50%, -50%);
            margin-left: auto;
         }
         .pre-loader-logo {
             height: 60px;
         }
        }
        @media (min-width:480px){
            // .loader-mobile {
            //     display:none;
            // }

        }
        /* styles for loader ends here */

    </style>

        <template is="dom-if" if="{{displayOverlay}}">
            <div class="app_processing_dialog vertical layout center-center">
                <div class="vertical layout center padding loader-mobile-background">
                    <oe-i18n-msg msgid="{{displayMessage}}" class="mdl-grid primary-dark-text-m loader-desktop"></oe-i18n-msg>
                    <paper-spinner id="app_processing_loader_spinner" class="loader-mobile mdl-grid sub-pre-loader" active></paper-spinner>
                    <!--<div role="img" class="loader-mobile sub-pre-loader">
                        <img alt="loading" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/loader/your-bank-logo.gif" class="pre-loader-logo loader-mobile">
                        <p class="pre-loader-text loader-mobile secondary-dark-text-m text-align-center margin-b-zero margin-t-zero"><oe-i18n-msg msgid="{{displayMessage}}" ></oe-i18n-msg></p>
                    </div> -->
                </div>    
            </div>
        </template>
    `;

Polymer({
    is: "app-processing-loader",
    _template: template,
    properties: {
    /* Url for processor loader image */
        imageBaseUrl: {
            type: String,
            value: window.OEUtils.uibaseroute
        },
    /* property for tenant Id */
        tenantId: {
            type: String,
            value: sessionStorage.getItem("tenantId")
        }
    },
    attached: function () {
        var self = this;
        window.addEventListener('start-processing-loader', function (event) {
            self.displayMessage = 'm_processing';

            if (!_.isEmpty(event.detail))
                self.displayMessage = event.detail;

            self.displayOverlay = true;
        });
        window.addEventListener('stop-processing-loader', function () {
            self.displayOverlay = false;
        });
    }
});